import { useState, useEffect, useCallback } from "react";
import VlogDetails from "../VlogDetails/VlogDetails";
import ShareVlog from "../ShareVlog/ShareVlog";
import MetaTags from "../MetaTags/MetaTags";
import BlogRenderer from "../Renderer/BlogRenderer/BlogRenderer";
import GoToTopButton from "../PurpleButton/GoToTopButton";

const VlogViewer = ({ selectedVlog }) => {
  const [content, setContent] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const fetchVlogContent = async () => {
      if (!selectedVlog) return;

      try {
        const response = await fetch(`/${selectedVlog}.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setContent(data);
      } catch (error) {
        console.error("Error loading vlog:", error);
        window.location.href = "/";
      }
    };

    fetchVlogContent();
  }, [selectedVlog]);

  // Check if the screen is mobile-sized
  const checkIfMobile = useCallback(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, [checkIfMobile]);

  return (
    <>
      {content.vlogDetails && (
        <div className={`bg-white rounded ${!isMobile ? "card-body" : ""}`}>
          <div className="p-3">
            <VlogDetails vlogDetails={content.vlogDetails} />
            <div className="card-text border-5 border-card-top mt-2 pt-3">
              <BlogRenderer blogContent={content.content} />
              <ShareVlog vlogId={content.vlogDetails.VlogId} />
            </div>
          </div>

          <MetaTags
            title={content.vlogDetails.VlogTitle}
            description={""}
            url={content.vlogDetails.VlogId}
          />
          <GoToTopButton />
        </div>
      )}
    </>
  );
};

export default VlogViewer;
